import React from 'react';
import { Link } from 'react-router-dom';
import Box, { Item } from 'devextreme-react/box';
import { ApplicationApi } from '@apply/api';
import { applicationInsights } from '../ApplicationInsights';
import { formatDateTime } from '../common/SharedFunctions';
import { SectionHeader } from '../common/SharedComponents';
import { getLoanTypeName } from '../loans/common/LoanFunctions';

function ApplicationLanding() {
    const applicationApi = new ApplicationApi.ApplicationApi(applicationInsights);

    const [recentApplications, set_recentApplications] = React.useState<[ApplicationApi.IRecentApplication] | null>(null);

    React.useEffect(() => {
        _loadRecentApplications();
    }, []);

    const _loadRecentApplications = async () => {
        const response = await applicationApi.getRecentApplications();

        if (response.statusCode !== 200) return;

        set_recentApplications(response.result);
    };

    const styles = {
        flexContainer: {
            display: 'flex',
            flexDirection: 'row' as const,
            justifyContent: 'space-evenly' as const,
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <SectionHeader title='Applications' />
            <div
                className='row scrollable-content'
                style={styles.flexContainer}
            >
                <Link
                    to='/applications/incomplete'
                    style={styles.verticalPadding}
                >
                    <Box className='dx_box_applications'>
                        <Item>
                            <h1>Incomplete</h1>
                        </Item>
                        <Item>
                            <p>Manage Incomplete applications.</p>
                        </Item>
                    </Box>
                </Link>
                <Link
                    to='/applications/submitted'
                    style={styles.verticalPadding}
                >
                    <Box className='dx_box_applications'>
                        <Item>
                            <h1>Submitted</h1>
                        </Item>
                        <Item>
                            <p>Manage Submitted applications.</p>
                        </Item>
                    </Box>
                </Link>
                <Link
                    to='/applications/appraise'
                    style={styles.verticalPadding}
                >
                    <Box className='dx_box_applications'>
                        <Item>
                            <h1>Appraise</h1>
                        </Item>
                        <Item>
                            <p>Update appraisal pipeline.</p>
                        </Item>
                    </Box>
                </Link>
                <Link
                    to='/applications/recyclebin'
                    style={styles.verticalPadding}
                >
                    <Box className='dx_box_applications'>
                        <Item>
                            <h1>Declined</h1>
                        </Item>
                        <Item>
                            <p>View Lost & Declined applications.</p>
                        </Item>
                    </Box>
                </Link>
                <div className='columns small-12 large-12'>
                    <h2 className='decorated'> </h2>
                </div>
                <div
                    className='columns small-12 large-12'
                    style={styles.flexContainer}
                >
                    <Box className='dx_box_applications_recent'>
                        <Item>
                            <h6>Most Recent Applications (past 72 hours):</h6>
                        </Item>
                        <Item>
                            <table>
                                <tbody>
                                    {recentApplications &&
                                        recentApplications.map((application, index) => (
                                            <tr key={index}>
                                                <td>{application.name}</td>
                                                <td>{application.entity}</td>
                                                <td>{getLoanTypeName(application.loanTypeId)}</td>
                                                <td>
                                                    <i>{formatDateTime(new Date(application.createdAt + '+00:00'))}</i>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </Item>
                    </Box>
                </div>
            </div>
        </>
    );
}

export default ApplicationLanding;
